"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var RouterModule_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouterModule = void 0;
const core_1 = require("@rxdi/core");
const router_component_1 = require("./router.component");
const injection_tokens_1 = require("./injection.tokens");
const helpers_1 = require("./helpers");
let RouterModule = RouterModule_1 = class RouterModule {
    static forRoot(routes, options) {
        return {
            module: RouterModule_1,
            services: [
                {
                    provide: injection_tokens_1.RouterOptions,
                    useValue: options || {},
                },
                {
                    provide: injection_tokens_1.Routes,
                    useValue: (0, helpers_1.loadRoutes)(routes),
                },
            ],
            components: [router_component_1.RouterComponent],
        };
    }
    static forChild(routes) {
        helpers_1.ChildRoutesObservable.next((0, helpers_1.loadRoutes)(routes));
        return RouterModule_1;
    }
};
RouterModule = RouterModule_1 = __decorate([
    (0, core_1.Module)()
], RouterModule);
exports.RouterModule = RouterModule;
__exportStar(require("./injection.tokens"), exports);
__exportStar(require("./outlet"), exports);
__exportStar(require("./decorators"), exports);
__exportStar(require("./router.component"), exports);
__exportStar(require("./not-found.component"), exports);
__exportStar(require("./helpers"), exports);
